
import { add } from './position';


export default (function (droppable, point) {
  var closestScrollable = droppable.viewport.closestScrollable;
  if (!closestScrollable) {
    return point;
  }

  return add(point, closestScrollable.scroll.diff.displacement);
});


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/state/with-droppable-displacement.js
// module id = 204
// module chunks = 1